import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=5c5bbfa9&scoped=true&"
import script from "./noData.vue?vue&type=script&lang=js&"
export * from "./noData.vue?vue&type=script&lang=js&"
import style0 from "./noData.vue?vue&type=style&index=0&id=5c5bbfa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5bbfa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c5bbfa9')) {
      api.createRecord('5c5bbfa9', component.options)
    } else {
      api.reload('5c5bbfa9', component.options)
    }
    module.hot.accept("./noData.vue?vue&type=template&id=5c5bbfa9&scoped=true&", function () {
      api.rerender('5c5bbfa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/noData.vue"
export default component.exports